exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.minibio[data-v-d6b7f508] {\n  font-size: 16px;\n  line-height: 1.5em;\n  text-align: left;\n}\np[data-v-d6b7f508] {\n  margin-bottom: 12px;\n}\n\n", ""]);

// exports
